export function ArticleText({article}){
    return (
        <section className="pb-0 pt-3">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 dropcap-style-01"
                         data-anime='{ "el": "childs", "translateY": [50, 0], "opacity": [0,1], "duration": 1200, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                        <article dangerouslySetInnerHTML={{ __html: article }}></article>
                    </div>
                </div>
            </div>
        </section>
    )
}